export enum TipoProduto {
    EQUIPAMENTO = 'EQUIPAMENTO',
    MATERIAL = 'MATERIAL',
    MEDICAMENTO = 'MEDICAMENTO'
}
